import React from 'react'

const Header = () => {
  return (
    <div className='header' style={{height:'5vh'}}>

        <h3 style={{ display:'flex' , justifyContent:'center' , alignItems:'center' , marginBottom:0 , height:'inherit'}}>UNIVERSAL LIBRARY</h3>

    </div>
  )
}

export default Header